import { lazyWithPreload } from '../lib/lazyWithPreload';

// Route pages, code-split. main.tsx preloads the current one before React
// mounts over a pre-rendered page, so the first render never suspends.
export const DestinationPage = lazyWithPreload(() => import('./DestinationPage'));
export const Explore = lazyWithPreload(() => import('./Explore'));
export const TravelIntelligence = lazyWithPreload(() => import('./TravelIntelligence'));
export const CorporateTravel = lazyWithPreload(() => import('./CorporateTravel'));
export const KnowledgeHub = lazyWithPreload(() => import('./KnowledgeHub'));
export const KnowledgeArticle = lazyWithPreload(() => import('./KnowledgeArticle'));
export const NotFound = lazyWithPreload(() => import('./NotFound'));
export const Privacy = lazyWithPreload(() => import('./Privacy'));
export const About = lazyWithPreload(() => import('./About'));

const EXACT_ROUTES: Record<string, { preload: () => Promise<void> }> = {
  '/explore': Explore,
  '/travel-intelligence': TravelIntelligence,
  '/corporate-travel': CorporateTravel,
  '/knowledge': KnowledgeHub,
  '/privacy': Privacy,
  '/about': About,
};

// Mirrors the <Routes> table in App.tsx. The home page is not code-split.
export function preloadRoute(pathname: string): Promise<void> {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/') return Promise.resolve();
  const exact = EXACT_ROUTES[path];
  if (exact) return exact.preload();
  if (/^\/destinations\/[^/]+$/.test(path)) return DestinationPage.preload();
  if (/^\/knowledge\/[^/]+$/.test(path)) return KnowledgeArticle.preload();
  return NotFound.preload();
}
